import React, { useState, useEffect } from "react";
import AdminTopNavBar from "../common/AdminTopNavBar";
import "../../styles/Admin.css";
import AdminFooter from "../common/AdminFooter";
import AdminSideBar from "./AdminSideBar";
import getUserMenuItems from "./AdminMenuContent";
import { api, adminReqConfig } from "../../include/api";
import { useNotification } from "../../Toast/ToastProvider";
import Spinner from "../add-ons/Spinner";
import "../../styles/CategoryProductList.css";
import { ERROR, SUCCESS } from "../../include/constant";
import { useNavigate, useParams } from "react-router-dom";
import {
  GoogleMap,
  Marker,
  useJsApiLoader,
  StandaloneSearchBox,
} from "@react-google-maps/api";
import Select from "react-select";
import CustomNumberInput2 from "../custom/CustomNumberInput2";

const customStyles = `
.col-5-lg {
flex: 0 0 20%;
max-width: 20%;
padding-left: 8px;
padding-right: 8px;
}
@media (max-width: 991px) {
.col-5-lg {
flex: 0 0 25%;
max-width: 25%;
}
}
@media (max-width: 767px) {
.col-5-lg {
flex: 0 0 33.333333%;
max-width: 33.333333%;
}
}
@media (max-width: 575px) {
.col-5-lg {
flex: 0 0 50%;
max-width: 50%;
}
}
`;

const AddDelivery = () => {
  const navigate = useNavigate();
  const { id: routeId } = useParams();
  const homeLink = "/admin";
  const [isSidebarMinimized, setIsSidebarMinimized] = useState(false);
  const [zoneName, setZoneName] = useState("");
  const [selectedZones, setSelectedZones] = useState([]);
  const [rateTiers, setRateTiers] = useState([
    {
      weightMin: "",
      weightMax: "",
      distanceMin: "",
      distanceMax: "",
      rate: "",
    },
  ]);
  const toast = useNotification();
  const [fetchingData, setFetchingData] = useState(true);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [saving, setSaving] = useState(false);
  const [zones, setZones] = useState([]);
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [brandOptions, setBrandOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [isAddZoneModalOpen, setIsAddZoneModalOpen] = useState(false);
  const [mapCenter] = useState({ lat: 13.0827, lng: 80.2707 });
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [latValue, setLatValue] = useState(null);
  const [lngValue, setLngValue] = useState(null);
  const [editingZone, setEditingZone] = useState(null);
  const [deletingZone, setDeletingZone] = useState(null);
  const [editDataLoaded, setEditDataLoaded] = useState(false);
  const [deliveryChargeId, setDeliveryChargeId] = useState(null);
  const [mapInstance, setMapInstance] = useState(null);
  const [searchBox, setSearchBox] = useState(null);

  const LIBRARIES = ["places"];
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyB9bx9PrNCA_4UbLa5PTXkjADxAVHFLbuU",
    libraries: LIBRARIES,
  });

  const onLoadMap = (map) => {
    setMapInstance(map);

    //Wait for places library
    if (!window.google?.maps?.places) {
      console.error("❌ Google Maps Places library not loaded");
      toast({ type: ERROR, message: "Search feature loading..." });
      return;
    }

    //Wait for map to be fully idle before adding controls
    window.google.maps.event.addListenerOnce(map, "idle", () => {
      // Create search input container with HIGH z-index
      const controlDiv = document.createElement("div");
      const controlDiv1 = document.createElement("div");
      controlDiv.style.cssText = `
      padding: 10px;
      z-index: 1000 !important;
      position: relative;
    `;

      const input = document.createElement("input");
      input.type = "text";
      input.placeholder = "Search location...";
      input.className = "form-control";
      input.id = "zone-search-input"; 
      input.style.cssText = `
      height: 40px;      
      border-radius: 6px;
      border: 1px solid #ccc;
      font-size: 14px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.2);
      background: #fff;
      z-index: 1001 !important;
      position: relative;
    `;

      input.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          e.stopPropagation();
          handleCustomSearch(input.value, map);
        }
      });

      // Current location button - UPDATED
      const btn = document.createElement("button");
      btn.innerHTML = "📍";
      btn.title = "Use current location";
      btn.type = "button";
      btn.style.cssText = `
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid #ccc;
  background: white;
  cursor: pointer;
  font-size: 18px;
  padding: 0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  margin: 10px 10px 10px 0 !important; /*
  z-index: 1001 !important;
  position: relative;
`;

      controlDiv.appendChild(input);
      controlDiv1.appendChild(btn);

      //  Change position from RIGHT_CENTER to TOP_RIGHT for better positioning
      map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(
        controlDiv,
      );
      map.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(
        controlDiv1,
      ); //  Changed from RIGHT_CENTER

      //  Initialize Autocomplete
      let autocomplete;
      try {
        autocomplete = new window.google.maps.places.Autocomplete(input, {
          fields: ["geometry", "name", "formatted_address", "place_id"],
          types: ["geocode"], // Returns addresses + coordinates
          componentRestrictions: { country: "in" },
        });

        // Bind to map viewport for better full-screen results
        // autocomplete.bindTo("bounds", map);

        //  SINGLE place_changed listener - delegate ALL cases to handlePlaceSelected
        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace();
          // Let handlePlaceSelected handle geometry, place_id, or name-only fallbacks
          handlePlaceSelected(place, map);
        });
      } catch (err) {
        console.error("❌ Autocomplete init failed:", err);
        toast({
          type: ERROR,
          message: "Search unavailable. Click on map to select location.",
        });
      }

      // Current location button handler
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!navigator.geolocation) {
          toast({ type: ERROR, message: "Geolocation not supported" });
          return;
        }

        btn.disabled = true;
        btn.style.opacity = "0.6";

        navigator.geolocation.getCurrentPosition(
          (pos) => {
            const newPosition = {
              lat: pos.coords.latitude,
              lng: pos.coords.longitude,
            };
            setSelectedPosition(newPosition);
            setLatValue(newPosition.lat);
            setLngValue(newPosition.lng);
            map.panTo(newPosition);
            map.setZoom(15);
            btn.disabled = false;
            btn.style.opacity = "1";
          },
          (err) => {
            console.error("Geolocation error:", err);
            toast({ type: ERROR, message: "Unable to fetch location" });
            btn.disabled = false;
            btn.style.opacity = "1";
          },
          { enableHighAccuracy: true, timeout: 10000 },
        );
      });
    }); // end idle listener
  };

  // Add this useEffect inside AddDelivery component (after other useEffects)
  useEffect(() => {
    if (isAddZoneModalOpen && mapInstance && isLoaded) {
      // Longer delay for full-screen layout to stabilize
      const timer = setTimeout(() => {
        window.google.maps.event.trigger(mapInstance, "resize");
        if (selectedPosition) {
          mapInstance.panTo(selectedPosition);
        }
        // Re-focus search input to trigger autocomplete
        const input = document.getElementById("zone-search-input");
        if (input) {
          input.focus();
          input.blur(); // Trigger re-initialization
        }
      }, 500); // Increased delay for full-screen
      return () => clearTimeout(timer);
    }
  }, [isAddZoneModalOpen, mapInstance, isLoaded, selectedPosition]);

  // Custom search input (no Google autocomplete dropdown)
  const handleCustomSearch = async (query, map) => {
    if (!query.trim()) return;

    try {
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(query)}&key=AIzaSyB9bx9PrNCA_4UbLa5PTXkjADxAVHFLbuU`,
      );
      const data = await res.json();

      if (data.status === "OK" && data.results?.[0]?.geometry?.location) {
        const loc = data.results[0].geometry.location;
        const newPos = { lat: loc.lat, lng: loc.lng };

        setSelectedPosition(newPos);
        setLatValue(loc.lat);
        setLngValue(loc.lng);
        map?.panTo(newPos);
        map?.setZoom(15);

        setZoneName((prev) =>
          !prev?.trim()
            ? data.results[0].formatted_address.split(",")[0]
            : prev,
        );
        toast({
          type: SUCCESS,
          message: `Found: ${data.results[0].formatted_address}`,
        });
      } else {
        toast({
          type: ERROR,
          message: `Could not find "${query}". Click map instead.`,
        });
      }
    } catch (err) {
      toast({ type: ERROR, message: "Search failed. Click map to select." });
    }
  };

  const handlePlaceSelected = (place, map) => {
    //Primary: Geometry available immediately
    if (place?.geometry?.location) {
      processLocation(
        place.geometry.location,
        place.name,
        place.formatted_address,
        map,
      );
      return;
    }

    if (place?.name && place.name.trim()) {
      fetchLocationViaGeocoding(place.name, map);
      return;
    }

    toast({
      type: ERROR,
      message:
        "Could not get location. Please try selecting again or click directly on the map.",
    });
  };

  const processLocation = (location, name, formattedAddress, map) => {
    const newPosition = {
      lat: location.lat(),
      lng: location.lng(),
    };

    setSelectedPosition(newPosition);
    setLatValue(newPosition.lat);
    setLngValue(newPosition.lng);

    map?.panTo(newPosition);
    map?.setZoom(15);

    // Update zone name if empty
    setZoneName((prev) => {
      if (!prev?.trim() && formattedAddress) {
        return formattedAddress.split(",")[0];
      }
      return prev;
    });

    toast({ type: SUCCESS, message: `Selected: ${name || "Location"}` });
  };

  const fetchLocationViaGeocoding = async (query, map) => {
    if (!query?.trim()) return;

    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(query)}&key=AIzaSyB9bx9PrNCA_4UbLa5PTXkjADxAVHFLbuU`,
      );
      const data = await response.json();

      if (data.status === "OK" && data.results?.[0]?.geometry?.location) {
        const loc = data.results[0].geometry.location;
        const newPosition = { lat: loc.lat, lng: loc.lng };

        processLocation(
          { lat: () => loc.lat, lng: () => loc.lng },
          query,
          data.results[0].formatted_address,
          map,
        );
      } else {
        toast({
          type: ERROR,
          message: `Could not find "${query}". Please click directly on the map.`,
        });
      }
    } catch (err) {
      toast({
        type: ERROR,
        message: "Search failed. Please click on map to select location.",
      });
    }
  };
  // BUTTON STYLING HELPERS
  const getButtonStyle = (isPrimary = false, isSmall = false) => ({
    border: "none",
    padding: isSmall ? "8px 12px" : "8px 20px",
    fontWeight: "500",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: saving ? "not-allowed" : "pointer",
    opacity: saving ? 0.7 : 1,
    fontSize: isSmall ? "14px" : "inherit",
    minWidth: isSmall ? "80px" : "auto",
    textAlign: "center",
    ...(isPrimary
      ? {
          backgroundColor: saving ? "#1565c0" : "#1976d2",
          color: "#fff",
        }
      : {
          backgroundColor: saving ? "#e0e0e0" : "#bed9f8ff",
          color: saving ? "#9e9e9e" : "#1976d2",
        }),
  });

  const renderLoadingSpinner = (size = "sm") => (
    <i
      className={`fa fa-spinner fa-spin ${size === "sm" ? "me-2" : "me-3"}`}
      aria-hidden="true"
      style={{ fontSize: size === "sm" ? "0.9rem" : "1.1rem" }}
    ></i>
  );

  const deliveryId = routeId ? parseInt(routeId, 10) : null;
  const isEditMode = !!deliveryId;
  const toggleSidebar = () => setIsSidebarMinimized(!isSidebarMinimized);
  const menuContent = getUserMenuItems();

  // Load category options for top-level select
  useEffect(() => {
    api
      .get("/category/?flag=exceptHome", adminReqConfig())
      .then((res) =>
        setCategoryOptions(
          (res.data.data || [])
            .filter((cat) => cat.parentId === 0)
            .map((c) => ({ value: c.id, label: c.name })),
        ),
      )
      .catch(() => setCategoryOptions([]));
  }, []);

  // Fetch initial data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [brandsRes, categoriesRes, productsRes, zonesRes] =
          await Promise.all([
            api
              .get("/brand/", adminReqConfig())
              .catch(() => ({ data: { data: [] } })),
            api
              .get("/category/?flag=exceptHome", adminReqConfig())
              .catch(() => ({ data: { data: [] } })),
            api
              .get("/product/?limit=200", adminReqConfig())
              .catch(() => ({ data: { data: [] } })),
            api
              .get("/zone/", adminReqConfig())
              .catch(() => ({ data: { data: [] } })),
          ]);
        setBrands(brandsRes.data.data || []);
        const topLevelCategories =
          categoriesRes.data.data?.filter((cat) => cat.parentId === 0) || [];
        setCategories(topLevelCategories);
        setProducts(productsRes.data.data || []);
        setZones(zonesRes.data.data || []);
      } catch (error) {
        console.error("Error fetching initial data:", error);
        setBrands([]);
        setCategories([]);
        setProducts([]);
        setZones([]);
      } finally {
        setFetchingData(false);
      }
    };
    fetchData();
  }, []);

  // Reset editDataLoaded when not in edit mode
  useEffect(() => {
    if (!isEditMode) {
      setEditDataLoaded(false);
      setDeliveryChargeId(null);
    }
  }, [isEditMode]);

  // Load brands based on selected categories
  useEffect(() => {
    if (!selectedCategory || selectedCategory.length === 0) {
      setBrandOptions([]);
      setProductOptions([]);
      if (!isEditMode || !editDataLoaded) {
        setSelectedBrand([]);
        setSelectedProduct([]);
      }
      return;
    }
    const categoryIds = selectedCategory.map((cat) => cat.value);
    api
      .get(`/brand/?categoryId=${categoryIds.join(",")}`, adminReqConfig())
      .then((res) => {
        const brands =
          res.data.data?.map((b) => ({ value: b.id, label: b.name })) || [];
        setBrandOptions(brands);
        if (!isEditMode || !editDataLoaded) {
          setSelectedBrand([]);
          setSelectedProduct([]);
        }
      })
      .catch(() => {
        setBrandOptions([]);
        if (!isEditMode || !editDataLoaded) {
          setSelectedBrand([]);
          setSelectedProduct([]);
        }
      });
  }, [selectedCategory, isEditMode, editDataLoaded]);

  // Load products based on selected brands & categories
  useEffect(() => {
    if (!selectedBrand || selectedBrand.length === 0) {
      setProductOptions([]);
      if (!isEditMode || !editDataLoaded) {
        setSelectedProduct([]);
      }
      return;
    }
    const brandIds = selectedBrand.map((b) => b.value);
    const categoryIds = selectedCategory.map((c) => c.value);
    api
      .get(
        `/product/?categoryId=${categoryIds.join(",")}&brandId=${brandIds.join(
          ",",
        )}`,
        adminReqConfig(),
      )
      .then((res) => {
        const products =
          res.data.data?.map((p) => ({ value: p.productId, label: p.name })) ||
          [];
        setProductOptions(products);
        if (!isEditMode || !editDataLoaded) {
          setSelectedProduct([]);
        }
      })
      .catch(() => {
        setProductOptions([]);
        if (!isEditMode || !editDataLoaded) {
          setSelectedProduct([]);
        }
      });
  }, [selectedCategory, selectedBrand, isEditMode, editDataLoaded]);

  // Fetch delivery details in edit mode
  useEffect(() => {
    const fetchDeliveryDetails = async () => {
      if (!isEditMode || !deliveryId) return;
      if (
        !zones.length ||
        !categories.length ||
        !brands.length ||
        !products.length
      )
        return;
      setLoadingDetails(true);
      try {
        const response = await api.get(
          `/delivery_charges/?id=${deliveryId}`,
          adminReqConfig(),
        );
        if (response.status === 200 && response.data.data?.length > 0) {
          // ✅ FIX: Get the first item from data array
          const data = response.data.data[0];
          // Store delivery charge ID for child items
          setDeliveryChargeId(data.id);
          // Zone
          const zoneId = data.zoneId;
          const selectedZoneObj = zones.find((z) => z.id === parseInt(zoneId));
          if (selectedZoneObj) setSelectedZones([selectedZoneObj.name]);
          // Categories - handle array of strings
          const categoryList = Array.isArray(data.categoryList)
            ? data.categoryList.map(Number).filter(Boolean)
            : typeof data.categoryList === "string"
              ? data.categoryList.split(",").map(Number).filter(Boolean)
              : [];
          const selectedCategoryOpts = categories
            .filter((c) => categoryList.includes(c.id))
            .map((c) => ({ value: c.id, label: c.name }));
          setSelectedCategory(selectedCategoryOpts);
          // Brands - handle array of strings
          const brandList = Array.isArray(data.brandList)
            ? data.brandList.map(Number).filter(Boolean)
            : typeof data.brandList === "string"
              ? data.brandList.split(",").map(Number).filter(Boolean)
              : [];
          const selectedBrandOpts = brands
            .filter((b) => brandList.includes(b.id))
            .map((b) => ({ value: b.id, label: b.name }));
          setSelectedBrand(selectedBrandOpts);
          // Products - handle array of strings
          const productList = Array.isArray(data.productList)
            ? data.productList.map(Number).filter(Boolean)
            : typeof data.productList === "string"
              ? data.productList.split(",").map(Number).filter(Boolean)
              : [];
          const selectedProductOpts = products
            .filter((p) => productList.includes(p.id))
            .map((p) => ({ value: p.id, label: p.name }));
          setSelectedProduct(selectedProductOpts);
          // Rate tiers - from deliveryChargeItems (child records)
          if (data.deliveryChargeItems && data.deliveryChargeItems.length > 0) {
            setRateTiers(
              data.deliveryChargeItems.map((item) => ({
                id: item.id, // ✅ Include id for edit mode
                weightMin: item.minWeight?.toString() || "",
                weightMax: item.maxWeight?.toString() || "",
                distanceMin: item.minDistance?.toString() || "",
                distanceMax: item.maxDistance?.toString() || "",
                rate: item.rate?.toString() || "",
              })),
            );
          }
          setEditDataLoaded(true);
        } else {
          toast({ type: ERROR, message: "Delivery charge details not found." });
          navigate("/admin/deliveryCharge/deliveryChargeList");
        }
      } catch (error) {
        console.error("Error fetching delivery details:", error);
        toast({
          type: ERROR,
          message:
            error.response?.data?.message ||
            "Failed to load delivery charge details.",
        });
        navigate("/admin/deliveryCharge/deliveryChargeList");
      } finally {
        setLoadingDetails(false);
      }
    };
    fetchDeliveryDetails();
  }, [isEditMode, deliveryId, zones, categories, brands, products]);

  const addRateTier = () => {
    if (saving) return;
    setRateTiers([
      ...rateTiers,
      {
        weightMin: "",
        weightMax: "",
        distanceMin: "",
        distanceMax: "",
        rate: "",
      },
    ]);
  };

  const removeRateTier = (index) => {
    if (saving || rateTiers.length <= 1) return;
    setRateTiers(rateTiers.filter((_, i) => i !== index));
  };

  const handleClearAll = () => {
    if (saving) return;
    setZoneName("");
    setSelectedZones([]);
    setSelectedCategory([]);
    setSelectedBrand([]);
    setSelectedProduct([]);
    setRateTiers([
      {
        weightMin: "",
        weightMax: "",
        distanceMin: "",
        distanceMax: "",
        rate: "",
      },
    ]);
    setSelectedPosition(null);
    setLatValue(null);
    setLngValue(null);
    setEditDataLoaded(false);
    setDeliveryChargeId(null);
  };

  const handleEditZone = (zone) => {
    if (saving) return;
    setEditingZone(zone);
    setZoneName(zone.name);
    setLatValue(zone.latValue);
    setLngValue(zone.longValue);
    setSelectedPosition({ lat: zone.latValue, lng: zone.longValue });
    setIsAddZoneModalOpen(true);
  };

  const handleDeleteZone = async (zone) => {
    if (saving) return;
    if (!window.confirm(`Are you sure you want to delete zone "${zone.name}"?`))
      return;
    setDeletingZone(zone.id);
    try {
      const response = await api.delete(
        `/zone/?id=${zone.id}/`,
        adminReqConfig(),
      );
      if (response.status === 200) {
        toast({ type: SUCCESS, message: "Zone deleted successfully!" });
        navigate("/admin/deliveryCharge/deliveryChargeList");
        const zonesRes = await api.get("/zone/", adminReqConfig());
        setZones(zonesRes.data.data || []);
      } else {
        throw new Error(response.data.message || "Failed to delete zone");
      }
    } catch (err) {
      toast({ type: ERROR, message: err.message || "Failed to delete zone" });
    } finally {
      setDeletingZone(null);
    }
  };

  const handleAddZone = async () => {
    if (saving) return;
    if (!zoneName.trim()) {
      toast({ type: ERROR, message: "Zone name is required" });
      return;
    }
    if (!latValue || !lngValue) {
      toast({ type: ERROR, message: "Please select a location on the map" });
      return;
    }
    try {
      const zoneData = {
        shopId: 1,
        name: zoneName,
        latValue: latValue,
        longValue: lngValue,
      };
      let response;
      if (editingZone) {
        response = await api.put(
          `/zone/?id=${editingZone.id}/`,
          zoneData,
          adminReqConfig(),
        );
      } else {
        response = await api.post("/zone/", zoneData, adminReqConfig());
      }
      if (response.data.message?.toLowerCase().includes("successfully")) {
        toast({
          type: SUCCESS,
          message: editingZone
            ? "Zone updated successfully!"
            : "Zone added successfully!",
        });
        const zonesRes = await api.get("/zone/", adminReqConfig());
        setZones(zonesRes.data.data || []);
        setZoneName("");
        setSelectedPosition(null);
        setLatValue(null);
        setLngValue(null);
        setEditingZone(null);
        setIsAddZoneModalOpen(false);
      } else {
        toast({
          type: ERROR,
          message: response.data.message || "Operation failed",
        });
      }
    } catch (err) {
      toast({
        type: ERROR,
        message: `Failed to ${editingZone ? "update" : "add"} zone. Please try again.`,
      });
      console.error(err);
    }
  };

  const closeAddZoneModal = () => {
    if (saving) return;
    setIsAddZoneModalOpen(false);
    setEditingZone(null);
    setZoneName("");
    setSelectedPosition(null);
    setLatValue(null);
    setLngValue(null);
  };

  const validate = () => {
    if (!zoneName.trim() && selectedZones.length === 0) {
      toast({
        type: ERROR,
        message: "Please enter a new zone or select an existing zone",
      });
      return false;
    }
    if (!selectedCategory || selectedCategory.length === 0) {
      toast({ type: ERROR, message: "Please select at least one category" });
      return false;
    }
    // Validate rate tiers
    for (let i = 0; i < rateTiers.length; i++) {
      const tier = rateTiers[i];
      if (
        !tier.weightMin ||
        !tier.weightMax ||
        !tier.distanceMin ||
        !tier.distanceMax ||
        !tier.rate
      ) {
        toast({
          type: ERROR,
          message: `Please fill all fields for tier ${i + 1}`,
        });
        return false;
      }
      if (parseFloat(tier.weightMin) >= parseFloat(tier.weightMax)) {
        toast({
          type: ERROR,
          message: `Weight minimum must be less than maximum for tier ${i + 1}`,
        });
        return false;
      }
      if (parseFloat(tier.distanceMin) >= parseFloat(tier.distanceMax)) {
        toast({
          type: ERROR,
          message: `Distance minimum must be less than maximum for tier ${i + 1}`,
        });
        return false;
      }
    }
    return true;
  };

  const handleSave = async () => {
    if (!validate()) return;
    setSaving(true);
    try {
      let zoneId = null;
      // Step 1: Handle zone selection/creation
      if (zoneName.trim()) {
        const zoneData = {
          shopId: 1,
          name: zoneName,
          latValue: latValue,
          longValue: lngValue,
        };
        const zoneResponse = await api.post(
          "/zone/",
          zoneData,
          adminReqConfig(),
        );
        if (zoneResponse.data.message?.toLowerCase().includes("successfully")) {
          zoneId =
            zoneResponse.data.zoneId?.toString() ||
            zoneResponse.data.id?.toString();
          toast({ type: SUCCESS, message: "Zone added successfully!" });
          const zonesRes = await api.get("/zone/", adminReqConfig());
          setZones(zonesRes.data.data || []);
        } else {
          throw new Error(zoneResponse.data.message || "Failed to add zone");
        }
      } else if (selectedZones.length > 0) {
        const selectedZone = zones.find((z) => z.name === selectedZones[0]);
        if (selectedZone) zoneId = selectedZone.id?.toString();
        else throw new Error("Selected zone not found");
      } else {
        throw new Error("No zone selected or provided");
      }

      // Step 2: Prepare parent delivery charge data
      const categoryIds = selectedCategory.map((opt) => parseInt(opt.value));
      const brandIds = selectedBrand.map((opt) => parseInt(opt.value));
      const productIds = selectedProduct.map((opt) => parseInt(opt.value));
      const deliveryChargeData = {
        zoneId: parseInt(zoneId),
        categoryList: categoryIds,
        brandList: brandIds,
        productList: productIds,
      };

      // Step 3: Save parent record FIRST - GET ID FROM RESPONSE
      let deliveryChargeResponse;
      let currentDeliveryChargeId = null;
      if (isEditMode && deliveryChargeId) {
        deliveryChargeResponse = await api.put(
          `/delivery_charges/?id=${deliveryChargeId}`,
          deliveryChargeData,
          adminReqConfig(),
        );
        currentDeliveryChargeId = deliveryChargeId;
      } else {
        deliveryChargeResponse = await api.post(
          "/delivery_charges/",
          deliveryChargeData,
          adminReqConfig(),
        );
        if (deliveryChargeResponse.status === 200) {
          currentDeliveryChargeId =
            deliveryChargeResponse.data.id ||
            deliveryChargeResponse.data.deliveryChargeId ||
            deliveryChargeResponse.data.data?.id;
          if (!currentDeliveryChargeId) {
            throw new Error("Failed to get delivery charge ID from response");
          }
          setDeliveryChargeId(currentDeliveryChargeId);
        }
      }

      if (deliveryChargeResponse.status !== 200) {
        throw new Error(
          deliveryChargeResponse.data.message ||
            (isEditMode
              ? "Failed to update delivery charges"
              : "Failed to save delivery charges"),
        );
      }

      // Step 4: Prepare child items
      const deliveryChargeItemsData = rateTiers.map((tier) => {
        const item = {
          deliveryChargeId: currentDeliveryChargeId,
          minDistance: parseFloat(tier.distanceMin),
          maxDistance: parseFloat(tier.distanceMax),
          minWeight: parseFloat(tier.weightMin),
          maxWeight: parseFloat(tier.weightMax),
          rate: parseFloat(tier.rate),
        };
        if (tier.id) {
          item.id = tier.id;
        }
        return item;
      });

      //Step 5: SEPARATE items with ID and without ID
      const itemsWithId = deliveryChargeItemsData.filter((item) => item.id);
      const itemsWithoutId = deliveryChargeItemsData.filter((item) => !item.id);

      //Step 6: Save items separately
      if (itemsWithId.length > 0) {
        // UPDATE existing items
        const updateResponse = await api.put(
          "/delivery_charge_items/",
          itemsWithId,
          adminReqConfig(),
        );
        if (updateResponse.status !== 200) {
          throw new Error(
            updateResponse.data.message || "Failed to update items",
          );
        }
      }

      if (itemsWithoutId.length > 0) {
        // CREATE new items
        const createResponse = await api.post(
          "/delivery_charge_items/",
          itemsWithoutId,
          adminReqConfig(),
        );
        if (createResponse.status !== 200) {
          throw new Error(
            createResponse.data.message || "Failed to create new items",
          );
        }
      }

      toast({
        type: SUCCESS,
        message: isEditMode
          ? "Delivery charges updated successfully!"
          : "Delivery charges saved successfully!",
      });
      handleClearAll();
      navigate("/admin/deliveryCharge/deliveryChargeList");
    } catch (err) {
      toast({
        type: ERROR,
        message:
          err.message ||
          (isEditMode
            ? "Failed to update delivery charges. Please try again."
            : "Failed to save delivery charges. Please try again."),
      });
      console.error("Save error:", err);
    } finally {
      setSaving(false);
    }
  };

  const openAddZoneModal = () => {
    if (saving) return;
    setIsAddZoneModalOpen(true);
  };

  const selectStyles = {
    container: (provided) => ({
      ...provided,
      width: "300px",
      maxWidth: "100%",
      margin: 0,
    }),
    control: (provided, state) => ({
      ...provided,
      minHeight: "54px",
      height: "54px",
      padding: "0 8px",
      border: "1px solid #c7d7f5",
      borderRadius: "5px",
      boxShadow: "none",
      backgroundColor: state.isDisabled ? "#f8f9fa" : "transparent",
      overflowX: "auto",
      overflowY: "hidden",
      "& > div:first-child": {
        display: "flex",
        flexWrap: "nowrap",
        minWidth: "fit-content",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0",
      flexWrap: "nowrap",
      display: "flex",
      alignItems: "center",
      minHeight: "40px",
    }),
    multiValue: (provided) => ({
      ...provided,
      margin: "4px 2px",
      backgroundColor: "#e3f2fd",
      border: "1px solid #123456",
      borderRadius: "4px",
      padding: "2px 6px",
      whiteSpace: "nowrap",
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
      minWidth: "80px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#999",
      whiteSpace: "nowrap",
      position: "absolute",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "40px",
      alignSelf: "center",
    }),
  };

  const inputStyle = {
    borderRadius: "6px",
    fontWeight: "400",
    outline: "none",
    width: "100%",
    padding: "10px 16px",
    backgroundColor: "transparent !important",
    border: "1px solid #d1d5db",
    color: "#1f2937",
  };

  const pageTitle = isEditMode
    ? "EDIT DELIVERY CHARGES"
    : "ADD DELIVERY CHARGES";

  if (fetchingData || (isEditMode && loadingDetails)) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Spinner color="primary" />
      </div>
    );
  }

  return (
    <>
      <style>{customStyles}</style>
      <style>
        {`
        .table-bordered td:last-child,
        .table-bordered th:last-child {
          border-right: 1px solid #dee2e6 !important;
        }
        `}
      </style>
      <AdminSideBar
        menuContent={menuContent}
        isMinimized={isSidebarMinimized}
      />
      <AdminTopNavBar
        toggleSidebar={toggleSidebar}
        isSidebarMinimized={isSidebarMinimized}
        homeLink={homeLink}
        title={pageTitle}
      />
      <div
        className="content-wrapper p-0"
        style={{
          marginLeft: isSidebarMinimized ? "80px" : "250px",
          flex: "1",
        }}
      >
        <section
          style={{
            backgroundColor: "#F1F4F9",
            padding: "30px",
            marginTop: "70px",
            marginBottom: "40px",
            minHeight: "80vh",
          }}
        >
          <div className="container-fluid">
            {/* Select Zone Section */}
            <div className="card mb-22 border-0" style={{ height: "auto" }}>
              <div className="d-flex align-items-center pe-16 ps-16 pt-16 justify-content-between">
                <h6 className="mb-0 fs-5">Select Zone</h6>
                <div className="d-flex gap-2">
                  <button
                    onClick={() => {
                      if (saving) return;
                      if (selectedZones.length > 0) {
                        const selectedZone = zones.find(
                          (zone) => zone.name === selectedZones[0],
                        );
                        if (selectedZone) handleEditZone(selectedZone);
                        else {
                          toast({
                            type: ERROR,
                            message: "Please select a zone to edit",
                          });
                        }
                      } else {
                        toast({
                          type: ERROR,
                          message: "Please select a zone to edit",
                        });
                      }
                    }}
                    disabled={saving}
                    style={getButtonStyle(false, true)}
                  >
                    {saving ? (
                      <>
                        {renderLoadingSpinner("sm")}
                        Processing...
                      </>
                    ) : (
                      <>
                        <img
                          src="/assets/images/edit-icon.png"
                          alt="Edit"
                          style={{
                            width: "14px",
                            height: "14px",
                            objectFit: "contain",
                            marginRight: "4px",
                          }}
                          onError={(e) => (e.target.style.display = "none")}
                        />
                        Edit
                      </>
                    )}
                  </button>
                  <button
                    onClick={() => {
                      if (saving) return;
                      if (selectedZones.length > 0) {
                        const selectedZone = zones.find(
                          (zone) => zone.name === selectedZones[0],
                        );
                        if (selectedZone) handleDeleteZone(selectedZone);
                        else {
                          toast({
                            type: ERROR,
                            message: "Please select a zone to delete",
                          });
                        }
                      } else {
                        toast({
                          type: ERROR,
                          message: "Please select a zone to delete",
                        });
                      }
                    }}
                    disabled={saving || deletingZone}
                    style={getButtonStyle(false, true)}
                  >
                    {saving ? (
                      <>
                        {renderLoadingSpinner("sm")}
                        Processing...
                      </>
                    ) : (
                      <>
                        <img
                          src="/assets/images/delete-icon.png"
                          alt="Delete"
                          style={{
                            width: "14px",
                            height: "14px",
                            objectFit: "contain",
                            marginRight: "4px",
                          }}
                          onError={(e) => (e.target.style.display = "none")}
                        />
                        Delete
                      </>
                    )}
                  </button>
                  <button
                    onClick={() => !saving && setSelectedZones([])}
                    disabled={saving}
                    style={getButtonStyle(false, true)}
                  >
                    {saving ? (
                      <>
                        {renderLoadingSpinner("sm")}
                        Clearing...
                      </>
                    ) : (
                      "Clear"
                    )}
                  </button>
                  {!isEditMode && (
                    <button
                      onClick={openAddZoneModal}
                      disabled={saving}
                      style={getButtonStyle(true, true)}
                    >
                      {saving ? (
                        <>
                          {renderLoadingSpinner("sm")}
                          Processing...
                        </>
                      ) : (
                        "Add Zone"
                      )}
                    </button>
                  )}
                </div>
              </div>
              <div
                className="row text-center ms-16 me-16 mt-16 mb-40 p-16"
                style={{
                  backgroundColor: "#F1F4F9",
                  height: "auto",
                  borderRadius: "6px",
                }}
              >
                <div className="col-12">
                  <div className="row">
                    {zones.map((zone) => {
                      const isSelected = selectedZones.includes(zone.name);
                      return (
                        <div
                          className="col-12 col-sm-6 col-md-4 col-5-lg mb-2"
                          key={zone.id}
                        >
                          <div className="d-flex align-items-center justify-content-between">
                            <label
                              className={`d-flex align-items-center cursor-pointer w-100`}
                              htmlFor={`zone-${zone.id}`}
                            >
                              <input
                                type="radio"
                                name="zone"
                                className="form-check-input me-5"
                                id={`zone-${zone.id}`}
                                checked={isSelected}
                                disabled={saving}
                                onChange={() =>
                                  !saving && setSelectedZones([zone.name])
                                }
                              />
                              <span className="flex-grow-1 text-start text-capitalize">
                                {zone.name}
                              </span>
                            </label>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className="card border-0">
              <div className="d-flex justify-content-between align-items-center ps-16 pe-16 pt-16 pb-0">
                <h6 className="mb-0 fs-5">Charges Details</h6>
                <button
                  onClick={handleClearAll}
                  disabled={saving}
                  style={getButtonStyle(false)}
                >
                  {saving ? (
                    <>
                      {renderLoadingSpinner("sm")}
                      Clearing...
                    </>
                  ) : (
                    "Clear"
                  )}
                </button>
              </div>
              <div className="card-body">
                <div className="row mb-32">
                  <div className="col-md-12">
                    <div className="d-flex gap-20">
                      {/* Category */}
                      <div className="flex-grow-1">
                        <h6 className="text-md mb-8 fw-bold">Category</h6>
                        <Select
                          isMulti
                          value={selectedCategory}
                          onChange={(val) =>
                            !saving && setSelectedCategory(val)
                          }
                          options={categoryOptions}
                          placeholder="Select category"
                          isClearable
                          isSearchable
                          isDisabled={saving}
                          className="coupon-add-select"
                          classNamePrefix="select"
                          styles={selectStyles}
                        />
                      </div>
                      {/* Brand */}
                      <div className="flex-grow-1">
                        <h6 className="text-md mb-8 fw-bold">Brand</h6>
                        <Select
                          isMulti
                          value={selectedBrand}
                          onChange={(val) => !saving && setSelectedBrand(val)}
                          options={brandOptions}
                          placeholder={
                            selectedCategory.length > 0
                              ? "Select brand"
                              : "Select category first"
                          }
                          isClearable
                          isSearchable
                          isDisabled={saving || selectedCategory.length === 0}
                          className="coupon-add-select"
                          classNamePrefix="select"
                          styles={selectStyles}
                        />
                      </div>
                      {/* Product */}
                      <div className="flex-grow-1">
                        <h6 className="text-md mb-8 fw-bold">Product</h6>
                        <Select
                          isMulti
                          value={selectedProduct}
                          onChange={(val) => !saving && setSelectedProduct(val)}
                          options={productOptions}
                          placeholder={
                            selectedBrand.length > 0
                              ? "Select product"
                              : "Select brand first"
                          }
                          isClearable
                          isSearchable
                          isDisabled={saving || selectedBrand.length === 0}
                          className="coupon-add-select"
                          classNamePrefix="select"
                          styles={selectStyles}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* Charges Based On Section */}
                <div className="row mb-32">
                  <h6 className="text-md mb-8 fw-bold">Charges Based On</h6>
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Weight</th>
                          <th>Distance</th>
                          <th>Rate</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {rateTiers.map((tier, index) => (
                          <tr key={index}>
                            <td>
                              <div className="mb-2">
                                <h6 className="text-md fw-bold text-start">
                                  Minimum
                                </h6>
                                {/* <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter minimum"
                                  value={tier.weightMin}
                                  onWheel={(e) => e.preventDefault()}
                                  disabled={saving}
                                  onChange={(e) => {
                                    if (saving) return;
                                    const newTiers = [...rateTiers];
                                    newTiers[index].weightMin = e.target.value;
                                    setRateTiers(newTiers);
                                  }}
                                  style={inputStyle}
                                /> */}
                                <CustomNumberInput2
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter minimum"
                                  value={tier.weightMin}
                                  disabled={saving}
                                  onChange={(e) => {
                                    if (saving) return;
                                    const newTiers = [...rateTiers];
                                    newTiers[index].weightMin = e.target.value;
                                    setRateTiers(newTiers);
                                  }}
                                  style={inputStyle}
                                />
                              </div>
                              <div>
                                <h6 className="text-md fw-bold text-start">
                                  Maximum
                                </h6>
                                {/* <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter maximum"
                                  value={tier.weightMax}
                                  disabled={saving}
                                  onChange={(e) => {
                                    if (saving) return;
                                    const newTiers = [...rateTiers];
                                    newTiers[index].weightMax = e.target.value;
                                    setRateTiers(newTiers);
                                  }}
                                  style={inputStyle}
                                /> */}
                                <CustomNumberInput2
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter maximum"
                                  value={tier.weightMax}
                                  disabled={saving}
                                  onChange={(e) => {
                                    if (saving) return;
                                    const newTiers = [...rateTiers];
                                    newTiers[index].weightMax = e.target.value;
                                    setRateTiers(newTiers);
                                  }}
                                  style={inputStyle}
                                />
                              </div>
                            </td>
                            <td>
                              <div className="mb-2">
                                <h6 className="text-md fw-bold text-start">
                                  Minimum
                                </h6>
                                {/* <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter minimum"
                                  value={tier.distanceMin}
                                  disabled={saving}
                                  onChange={(e) => {
                                    if (saving) return;
                                    const newTiers = [...rateTiers];
                                    newTiers[index].distanceMin =
                                      e.target.value;
                                    setRateTiers(newTiers);
                                  }}
                                  style={inputStyle}
                                /> */}

                                <CustomNumberInput2
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter minimum"
                                  value={tier.distanceMin}
                                  disabled={saving}
                                  onChange={(e) => {
                                    if (saving) return;
                                    const newTiers = [...rateTiers];
                                    newTiers[index].distanceMin =
                                      e.target.value;
                                    setRateTiers(newTiers);
                                  }}
                                  style={inputStyle}
                                />
                              </div>
                              <div>
                                <h6 className="text-md fw-bold text-start">
                                  Maximum
                                </h6>
                                {/* <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter maximum"
                                  value={tier.distanceMax}
                                  disabled={saving}
                                  onChange={(e) => {
                                    if (saving) return;
                                    const newTiers = [...rateTiers];
                                    newTiers[index].distanceMax =
                                      e.target.value;
                                    setRateTiers(newTiers);
                                  }}
                                  style={inputStyle}
                                /> */}
                                <CustomNumberInput2
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter maximum"
                                  value={tier.distanceMax}
                                  disabled={saving}
                                  onChange={(e) => {
                                    if (saving) return;
                                    const newTiers = [...rateTiers];
                                    newTiers[index].distanceMax =
                                      e.target.value;
                                    setRateTiers(newTiers);
                                  }}
                                  style={inputStyle}
                                />
                              </div>
                            </td>
                            <td>
                              <h6 className="mt-32"></h6>
                              {/* <input
                                type="number"
                                className="form-control"
                                placeholder="Enter rate"
                                value={tier.rate}
                                disabled={saving}
                                onChange={(e) => {
                                  if (saving) return;
                                  const newTiers = [...rateTiers];
                                  newTiers[index].rate = e.target.value;
                                  setRateTiers(newTiers);
                                }}
                                style={inputStyle}
                              /> */}
                              <CustomNumberInput2
                                type="number"
                                className="form-control"
                                placeholder="Enter rate"
                                value={tier.rate}
                                disabled={saving}
                                onChange={(e) => {
                                  if (saving) return;
                                  const newTiers = [...rateTiers];
                                  newTiers[index].rate = e.target.value;
                                  setRateTiers(newTiers);
                                }}
                                style={inputStyle}
                              />
                            </td>
                            <td className="d-flex align-items-center justify-content-center pt-80 border-0 pb-80">
                              {rateTiers.length > 1 && (
                                <button
                                  onClick={() =>
                                    !saving && removeRateTier(index)
                                  }
                                  disabled={saving}
                                  style={{
                                    backgroundColor: saving
                                      ? "#e0e0e0"
                                      : "#bed9f8ff",
                                    color: saving ? "#9e9e9e" : "#2B95D3",
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "50%",
                                    fontSize: "20px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: saving ? "not-allowed" : "pointer",
                                    border: "none",
                                  }}
                                >
                                  {saving ? (
                                    <i
                                      className="fa fa-spinner fa-spin"
                                      style={{ fontSize: "14px" }}
                                    ></i>
                                  ) : (
                                    "-"
                                  )}
                                </button>
                              )}
                              {/* Show PLUS only in last row */}
                              {index === rateTiers.length - 1 && (
                                <button
                                  className="ms-6"
                                  onClick={() => !saving && addRateTier()}
                                  disabled={saving}
                                  style={{
                                    backgroundColor: saving
                                      ? "#e0e0e0"
                                      : "#bed9f8ff",
                                    color: saving ? "#9e9e9e" : "#2B95D3",
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "50%",
                                    fontSize: "20px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: saving ? "not-allowed" : "pointer",
                                    border: "none",
                                  }}
                                >
                                  {saving ? (
                                    <i
                                      className="fa fa-spinner fa-spin"
                                      style={{ fontSize: "14px" }}
                                    ></i>
                                  ) : (
                                    "+"
                                  )}
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="d-flex justify-content-end gap-8">
                  <button
                    onClick={handleSave}
                    disabled={saving}
                    style={getButtonStyle(true)}
                  >
                    {saving ? (
                      <>
                        {renderLoadingSpinner("sm")}
                        {isEditMode ? "Updating..." : "Adding..."}
                      </>
                    ) : isEditMode ? (
                      "Update"
                    ) : (
                      "Add"
                    )}
                  </button>
                  <button
                    onClick={handleClearAll}
                    disabled={saving}
                    style={getButtonStyle(false)}
                  >
                    {saving ? (
                      <>
                        {renderLoadingSpinner("sm")}
                        Clearing...
                      </>
                    ) : (
                      "Clear"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AdminFooter isSidebarMinimized={isSidebarMinimized} />
      {/* Add Zone Modal */}
      {isAddZoneModalOpen && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
          onClick={closeAddZoneModal}
        >
          <div
            className="modal-dialog modal-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <style>{`
  .pac-container {
    z-index: 99999 !important;
    border-radius: 6px !important;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
  }
  .modal-body {
    overflow: visible !important;
  }
`}</style>
            <div className="modal-content">
              <div className="modal-header">
                <h6 className="mb-0 fs-5">
                  {editingZone ? "Edit Zone" : "Add New Zone"}
                </h6>
                <button
                  onClick={closeAddZoneModal}
                  disabled={saving}
                  style={{
                    position: "absolute",
                    top: "12px",
                    right: "12px",
                    width: "32px",
                    height: "32px",
                    background: "none",
                    border: "3px solid #ddd",
                    borderRadius: "50%",
                    fontSize: "24px",
                    cursor: saving ? "not-allowed" : "pointer",
                    color: "#6E7C94",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: 0,
                    opacity: saving ? 0.5 : 1,
                  }}
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-8">
                    <div
                      className="position-relative"
                      style={{
                        height: "300px",
                        borderRadius: "8px",
                        overflow: "visible",
                        border: "1px solid #e5e7eb",
                      }}
                    >
                      {isLoaded ? (
                        <>
                          <GoogleMap
                            mapContainerStyle={{
                              width: "100%",
                              height: "100%",
                              position: "relative",
                              zIndex: 1,
                            }}
                            center={mapCenter}
                            zoom={10}
                            onLoad={onLoadMap}
                            onClick={(e) => {
                              if (saving) return;

                              const newPosition = {
                                lat: e.latLng.lat(),
                                lng: e.latLng.lng(),
                              };

                              setSelectedPosition(newPosition);
                              setLatValue(newPosition.lat);
                              setLngValue(newPosition.lng);
                            }}
                            options={{
                              fullscreenControl: false,
                            }}
                          >
                            {selectedPosition && (
                              <Marker position={selectedPosition} />
                            )}
                          </GoogleMap>
                        </>
                      ) : (
                        <div className="d-flex align-items-center justify-content-center h-100">
                          <Spinner color="primary" />
                        </div>
                      )}
                    </div>
                    {latValue && lngValue && (
                      <div className="mt-2">
                        <small className="text-muted">
                          Selected Location: {latValue}, {lngValue}
                        </small>
                      </div>
                    )}
                  </div>
                  <div className="col-lg-4">
                    <div className="mb-3">
                      <h6 className="text-md fw-bold text-start mb-6 mt-12">
                        New Zone Name
                      </h6>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter zone name"
                        value={zoneName}
                        disabled={saving}
                        onChange={(e) => !saving && setZoneName(e.target.value)}
                        style={inputStyle}
                      />
                    </div>
                    <div className="mb-3">
                      <h6 className="text-md fw-bold text-start mb-6 mt-12">
                        Latitude
                      </h6>
                      <input
                        type="text"
                        className="form-control"
                        value={latValue || ""}
                        readOnly
                        disabled={saving}
                        style={inputStyle}
                      />
                    </div>
                    <div className="mb-3">
                      <h6 className="text-md fw-bold text-start mb-6 mt-12">
                        Longitude
                      </h6>
                      <input
                        type="text"
                        className="form-control mb-12"
                        value={lngValue || ""}
                        readOnly
                        disabled={saving}
                        style={inputStyle}
                      />
                    </div>
                    <div className="d-flex justify-content-end gap-12 mt-3">
                      <button
                        onClick={handleAddZone}
                        disabled={saving}
                        style={getButtonStyle(true, true)}
                      >
                        {saving ? (
                          <>
                            {renderLoadingSpinner("sm")}
                            Processing...
                          </>
                        ) : editingZone ? (
                          "Update Zone"
                        ) : (
                          "Add Zone"
                        )}
                      </button>
                      <button
                        onClick={() => {
                          if (saving) return;
                          setZoneName("");
                          setSelectedPosition(null);
                          setLatValue(null);
                          setLngValue(null);
                        }}
                        disabled={saving}
                        style={getButtonStyle(false, true)}
                      >
                        {saving ? (
                          <>
                            {renderLoadingSpinner("sm")}
                            Clearing...
                          </>
                        ) : (
                          "Clear"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddDelivery;
